<template>
  <div class="jianjie">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <div class="main">
      <div class="title">
        <img
          class="left"
          src="../../assets/images/jiaoxuezhenrong/left.png"
          alt=""
        />
        <span>东国大学简介</span>
        <img
          class="right"
          src="../../assets/images/jiaoxuezhenrong/right.png"
          alt=""
        />
      </div>
      <span class="content"
        >东国大学创立于1906年，至今已有百年历史，是韩国一所极富盛名的综合研究型大学。在2021年QS世界大学排名中跻身世界500强，QS亚洲大学排名位列第96位。作为综合大学中影视传媒教育领域的标杆院校，东国大学的人文类、传媒类、戏剧电影类专业排名一直稳居韩国高校前列，在这些专业领域又以新闻传媒、演艺界、文化界名人辈出的戏剧电影系和影像研究生院而闻名。学校还拥有业界领先的影视教学与制作中心——忠武路影像中心。</span
      >
      <div class="liaojie">
        <div class="xuhao">
          <img src="../../assets/images/jianjie/icon1.png" alt="" />
          <div class="paiming">
            2021年QS世界大学排名
            <span>第456位</span>
          </div>
        </div>
        <div class="xuhao">
          <img src="../../assets/images/jianjie/icon2.png" alt="" />
          <div class="paiming">
            2021年QS亚洲大学排名
            <span>第96位</span>
          </div>
        </div>
        <div class="xuhao">
          <img src="../../assets/images/jianjie/icon3.png" alt="" />
          <div class="paiming">
            毕业生就业率排名全韩国
            <span>第5位</span>
          </div>
        </div>
        <div class="xuhao">
          <img src="../../assets/images/jianjie/icon4.png" alt="" />
          <div class="paiming">
            韩国
            <span>BK21</span>
            工程卓越高校
          </div>
        </div>
        <div class="xuhao">
          <img src="../../assets/images/jianjie/icon5.png" alt="" />
          <div class="paiming">
            获得国际商学院联合会
            <span>(AACSB)</span>
            认证
          </div>
        </div>
      </div>
      <span class="content"
        >东国大学设有首尔、庆州、高阳和美国洛杉矶4大校区，共开设15个本科院系和11个研究生院，拥有3万余名在校学生和学识渊博、经验丰富的教授队伍。首尔校区坐落在首尔市中区南山公园斜面，闹中取静，在校园内便可以俯瞰首尔市区全景，知名的影像大学院便隶属于该校区。学校紧邻地铁3号线东国大学站，交通非常便捷，周边有南山首尔塔、东大门、南大门、明洞等游览胜地。校园环境优美，静谧怡人，校区内学习生活设施一应俱全，是学生理想的就读之地。</span
      >
      <div class="yuanxiao">
        <img src="../../assets/images/jianjie/yuanxiao.png" alt="" />
      </div>
      <span class="content"
        >高阳校区为生命医学校区（BMC），坐落在京畿道高阳市一山东区，距离首尔市中心仅1个小时的车程；庆州校区位于新罗时代的千年古都——庆州市，该市是世界闻名的文化观光城市，被称为“没有屋顶的博物馆”；美国洛杉矶校区的前身为美国皇家大学，与东国大学签署合作意向书之后不久，更名为东国大学洛杉矶分校并正式并入东国大学，成为韩国第一所在海外拥有校区的大学。</span
      >
      <span class="content"
        >东国大学大学院通过产、学、研协作体系，增设了开发实用性尖端技术的个性化课程。此外，东大还与包括清华大学、北京大学、杜克大学、加州大学洛杉矶分校（UCLA）在内的302所世界知名大学签订了国际交流协议，始终保持紧密的学术交流合作。东国大学的名人校友遍布韩国演艺界，包括崔岷植、全智贤、赵寅成、安七炫、李玹雨、允儿、李昇基、孙娜恩等众多明星。</span
      >
      <div class="star">
        <div class="oneline">
          <ul>
            <li>
              <img src="../../assets/images/jianjie/person1.png" alt="" />
              <span>全智贤<br />演员</span>
            </li>
            <li>
              <img src="../../assets/images/jianjie/person2.png" alt="" />
              <span>赵寅成<br />演员</span>
            </li>
            <li>
              <img src="../../assets/images/jianjie/person3.png" alt="" />
              <span>允儿<br />歌手、少女时代成员</span>
            </li>
          </ul>
        </div>
        <div class="oneline twoline">
          <ul>
            <li>
              <img src="../../assets/images/jianjie/person4.png" alt="" />
              <span>宣美<br />歌手</span>
            </li>
            <li>
              <img src="../../assets/images/jianjie/person5.png" alt="" />
              <span>孙娜恩<br />歌手、APINK成员</span>
            </li>
            <li>
              <img src="../../assets/images/jianjie/person6.png" alt="" />
              <span>李昇基<br />演员、歌手</span>
            </li>
          </ul>
        </div>
      </div>
      <span class="content"
        >未来，东国大学的发展目标是进一步提高大学的教育和研究水准，以学生为中心、以全球为舞台把东国大学提升为世界高水平大学，致力于将学生培养成为具有国际视野，能够参与国际事务和国际竞争，并能为国家和社会进步作出贡献的高端人才。</span
      >
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  metaInfo() {
    return {
      title: "东国简介-东国概况-韩国东国大学中文官网",
      meta: [
        {
          name: "keywords",
          content: "东国大学介绍,东国大学信息,东国大学优势",
        },
        {
          name: "description",
          content: "",
        },
      ],
    };
  },
  name: "introduction",
  data() {
    return {};
  },
  activated() {
    this.$emit("handleTKD", "东国概况");
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.jianjie {
  width: 100%;
  margin-top: 134px;
  padding-bottom: 80px;
  .main {
    padding: 0 40px;
    padding-top: 60px;
    .title {
      display: flex;
      height: 39px;
      justify-content: center;
      align-items: center;
      .left {
        width: 34px;
        height: 16px;
        margin-right: 30px;
      }
      span {
        display: block;
        height: 39px;
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #f7901e;
        line-height: 39px;
      }
      .right {
        width: 34px;
        height: 16px;
        margin-left: 30px;
      }
    }
    .content {
      display: block;
      margin-top: 48px;
      padding-right: 2px;
      font-size: 26px;
      font-family: Source Han Sans CN;
      color: #3e3a39;
      line-height: 40px;
    }
    .liaojie {
      margin-top: 50px;
      .xuhao {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        height: 70px;
        background-color: #fff;
        box-shadow: 0px 0px 9px 0px rgba(62, 72, 107, 0.22);
        img {
          width: 24px;
          height: 40px;
          margin-left: 58px;
          margin-right: 42px;
        }
        .paiming {
          height: 26px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          color: #333333;
          line-height: 26px;
          span {
            line-height: 26px;
            font-size: 26px;
            color: #f18c39;
          }
        }
      }
      :nth-child(2) {
        img {
          width: 31px;
          height: 40px;
          margin-left: 54px;
          margin-right: 39px;
        }
      }
      :nth-child(3) {
        img {
          width: 21px;
          height: 41px;
          margin-left: 59px;
          margin-right: 44px;
        }
      }
      :nth-child(4) {
        img {
          width: 25px;
          height: 40px;
          margin-left: 57px;
          margin-right: 42px;
        }
      }
      :nth-child(5) {
        img {
          width: 35px;
          height: 40px;
          margin-left: 52px;
          margin-right: 37px;
        }
      }
    }
    .yuanxiao {
      margin: 0 auto;
      width: 323px;
      height: 262px;
      margin-top: 42px;
      img {
        width: 100%;
      }
    }
    .star {
      padding-top: 48px;
      .oneline {
        padding-right: 0px;
        ul {
          display: flex;
          padding: 0;
          margin: 0;
          li {
            width: 220px;
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 136px;
              height: 136px;
            }
            span {
              display: block;
              margin-top: 20px;
              font-size: 24px;
              font-family: Source Han Sans CN;
              color: #3e3a39;
              text-align: center;
              line-height: 30px;
            }
          }
        }
      }
      .twoline {
        margin-top: 37px;
      }
    }
  }
}
</style>
